import type { PendingOrder } from '@/types/pendingOrder';

const CALLBACK_ORDER_KEY = 'onepay_callback_order';
export const ONEPAY_RETURN_MESSAGE = 'onepay-return';

export type OnePayCallbackOrder = Pick<
  PendingOrder,
  'order_id' | 'order_codeTracking' | 'code' | 'paymentType'
>;

// A newly opened popup receives its own copy of the opener's session storage.
// Keep this separate from order_confirm, which may be cleared when the API reports PAID.
export function storeOnePayCallbackOrder(order: OnePayCallbackOrder) {
  sessionStorage.setItem(CALLBACK_ORDER_KEY, JSON.stringify({
    order_id: order.order_id,
    order_codeTracking: order.order_codeTracking,
    code: order.code,
    paymentType: order.paymentType,
  }));
}

export function readOnePayCallbackOrder(storage?: Storage) {
  try {
    const value = JSON.parse((storage ?? sessionStorage).getItem(CALLBACK_ORDER_KEY) || 'null');
    if (value?.paymentType !== 'ONEPAY' ||
      !['order_id', 'order_codeTracking', 'code'].every(key =>
        typeof value[key] === 'string' && value[key].trim().length > 0)) return;
    return value as OnePayCallbackOrder;
  } catch {
    return;
  }
}

export function clearOnePayCallbackOrder(
  order: Pick<PendingOrder, 'order_id' | 'order_codeTracking'>,
  storage?: Storage,
) {
  try {
    const pending = readOnePayCallbackOrder(storage);
    if (pending?.order_id === order.order_id && pending.order_codeTracking === order.order_codeTracking) {
      (storage ?? sessionStorage).removeItem(CALLBACK_ORDER_KEY);
    }
  } catch { /* Storage unavailable. */ }
}
